import { ptBR } from '@mui/material/locale';
import { createTheme } from '@mui/material/styles';
import { ICustomTheme } from './types/ICustomTheme';

// Importar estilos de componentes
import { getCardStyles, getChipStyles, getIconButtonStyles, getInputAdornmentStyles, getPaperStyles, getTooltipStyles, getTypographyStyles } from './components/basicComponents';
import { getDialogActionsStyles, getDialogContentStyles, getDialogStyles, getDialogTitleStyles } from './components/dialogComponents';
import { getAutocompleteStyles, getButtonStyles, getSelectStyles, getTextFieldStyles } from './components/inputComponents';
import { getDataGridProStyles, getDataGridStyles, getDrawerStyles, getMenuStyles } from './components/navigationComponents';
import { getCssBaselineStyles } from './styles/globalStyles';

export const convertToTheme = (themeOptions: ICustomTheme) => {
     const theme = createTheme(
          {
               ...themeOptions,
               components: {
                    MuiButton: getButtonStyles(),
                    MuiTextField: getTextFieldStyles(themeOptions),
                    MuiSelect: getSelectStyles(themeOptions),
                    MuiFormControl: {
                         styleOverrides: {
                              root: {
                                   // Garantir alinhamento consistente para size small
                                   '& .MuiInputLabel-root': {
                                        transform: 'translate(14px, 9px) scale(1)',
                                        '&.MuiInputLabel-shrink': {
                                             transform: 'translate(14px, -9px) scale(0.75)',
                                        },
                                        '&.MuiInputLabel-outlined': {
                                             transform: 'translate(14px, 9px) scale(1)',
                                             '&.MuiInputLabel-shrink': {
                                                  transform: 'translate(14px, -9px) scale(0.75)',
                                             },
                                        },
                                   },
                              },
                         },
                    },
                    MuiInputLabel: {
                         styleOverrides: {
                              root: {
                                   color: themeOptions.palette.text.secondary,
                                   fontWeight: 500,
                                   fontSize: '1rem',
                                   '&.Mui-focused': {
                                        color: themeOptions.palette.primary.main,
                                        fontWeight: 600,
                                   },
                                   '&.Mui-error': {
                                        color: themeOptions.palette.error.main,
                                   },
                              },
                              outlined: {
                                   transform: 'translate(14px, 9px) scale(1)',
                                   '&.MuiInputLabel-shrink': {
                                        transform: 'translate(14px, -9px) scale(0.75)',
                                   },
                              },
                         },
                    },
                    MuiAutocomplete: getAutocompleteStyles(themeOptions),
                    MuiInputAdornment: getInputAdornmentStyles(themeOptions),
                    MuiIconButton: getIconButtonStyles(),
                    MuiCard: getCardStyles(themeOptions),
                    MuiChip: getChipStyles(),
                    MuiPaper: getPaperStyles(),
                    MuiTypography: getTypographyStyles(themeOptions),
                    MuiTable: {
                         styleOverrides: {
                              root: {},
                         },
                    },
                    MuiTableHead: {
                         styleOverrides: {
                              root: {},
                         },
                    },
                    MuiTableBody: {
                         styleOverrides: {
                              root: {},
                         },
                    },
                    MuiTableRow: {
                         styleOverrides: {
                              root: {},
                         },
                    },
                    MuiTableCell: {
                         styleOverrides: {
                              root: {},
                         },
                    },
                    MuiTablePagination: {
                         styleOverrides: {
                              root: {
                                   '& .MuiTablePagination-toolbar': {
                                        paddingLeft: 0,
                                        paddingRight: 0,
                                   },
                                   '& .MuiTablePagination-spacer': {
                                        display: 'none', // Remove o spacer padrão para melhor controle
                                   },
                                   '& .MuiTablePagination-selectLabel': {
                                        marginBottom: 0,
                                   },
                                   '& .MuiTablePagination-displayedRows': {
                                        marginBottom: 0,
                                   },
                              },
                         },
                    },
                    MuiPagination: {
                         styleOverrides: {
                              root: {},
                         },
                    },
                    MuiDialog: getDialogStyles(themeOptions),
                    MuiDialogActions: getDialogActionsStyles(themeOptions),
                    MuiDialogTitle: getDialogTitleStyles(themeOptions),
                    MuiDialogContent: getDialogContentStyles(themeOptions),
                    MuiTooltip: getTooltipStyles(),
                    MuiCssBaseline: getCssBaselineStyles(themeOptions),
                    MuiDataGrid: getDataGridStyles(themeOptions),
                    MuiDataGridPro: getDataGridProStyles(themeOptions),
                    MuiMenu: getMenuStyles(themeOptions),
                    MuiDrawer: getDrawerStyles(themeOptions),
               },
          },
          ptBR,
     );

     return theme;
};
